import { c as _c } from "react/compiler-runtime";
import type { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import ProfileActivityLogs from "@/components/profile-activity/ProfileActivityLogs";
import type { RateMatter } from "@/types/enums";
export default function UserPageCombinedActivityLog(t0) {
  const $ = _c(7);
  const {
    initialActivityLogParams,
    matter,
    withMatterFilter: t1
  } = t0;
  const withMatterFilter = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== initialActivityLogParams || $[1] !== matter) {
    t2 = matter === undefined ? initialActivityLogParams : {
      ...initialActivityLogParams,
      matter
    };
    $[0] = initialActivityLogParams;
    $[1] = matter;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const params = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h3 className="tw-mb-0 tw-flex tw-items-center tw-gap-1.5 lg:tw-gap-2 tw-whitespace-nowrap tw-text-xs tw-uppercase tw-tracking-wider tw-text-iron-500 lg:tw-text-iron-100 lg:tw-text-xl lg:tw-normal-case lg:tw-tracking-normal tw-font-semibold"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="tw-h-3.5 tw-w-3.5 lg:tw-h-5 lg:tw-w-5 tw-flex-shrink-0 tw-text-iron-500"><path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" /></svg>Activity Log</h3>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== params || $[5] !== withMatterFilter) {
    t4 = <div><ProfileActivityLogs initialParams={params} withFilters={true} withMatterFilter={withMatterFilter}>{t3}</ProfileActivityLogs></div>;
    $[4] = params;
    $[5] = withMatterFilter;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}